<template>
  <div>
    <div class="box box-success">
      <div class="box-header with-border">
        <h3 class="box-title box-title-sub"><img src="/static/img/icons/deposito_legal.png"> Depósito Temporal</h3>
        <!-- <div class="pull-right">
          <button class="btn btn-sm btn-success btn-detail" @click="showDetail()">Ver Detalle</button>
        </div> -->
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-12">
                <chart-line :chart-data="chartData" :height="240"></chart-line>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-sm-12">
                <div style="width: 300px;" class="center-block">
                  <div style="width: 150px; border-right:1px solid #eee;" class="pull-left text-center">
                    <img src="/static/img/icons/ic_recived_containers@3x.png" style="vertical-align: text-bottom" alt="Recibidos" height="20" width="20">
                    <span class="span-value" v-bind:style="{color: this.colorReceived}">
                      {{this.fetchData.containersReceivedTemporaryDeposit | formatAmount}}
                    </span>
                    <br/>
                    <span class="span-unit">Contenedores</span>
                    <br/>
                    <span class="span-status">Recibidos</span>
                  </div>
                  <div style="width: 150px;" class="pull-right text-center">
                    <img src="/static/img/icons/ic_recived_shipped@3x.png" style="vertical-align: text-bottom" alt="Despachados" height="20" width="20">
                    <span class="span-value" v-bind:style="{color: this.colorShipped}">
                      {{this.fetchData.containersShippedTemporaryDeposit | formatAmount}}
                    </span>
                    <br/>
                    <span class="span-unit">Contenedores</span>
                    <br/>
                    <span class="span-status">Despachados</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import util from 'assets/js/util.js'
import constants from 'assets/js/constants.js'
import LineChart from 'charts/LineChart.js'

export default {
  name: 'TemporaryDepositSummary',
  props: [
    'mode',
    'fetchData'
  ],
  data () {
    return {
      chartData: {},
      colorReceived: '',
      colorShipped: ''
    }
  },
  watch: {
    fetchData: function (newVal, oldVal) {
      this.fillData()
    }
  },
  computed: {
    ...mapGetters([
      'dashboardFilter'
    ])
  },
  created () {
    this.colorReceived = constants.colorPalette.TemporaryDepositReceived
    this.colorShipped = constants.colorPalette.TemporaryDepositShipped
  },
  mounted () {
    this.fillData()
  },
  methods: {
    fillData () {
      this.chartData = {
        labels: util.getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.containersReceivedTemporaryValuesDeposit),
            label: 'Recibido',
            borderColor: constants.colorPalette.TemporaryDepositReceived,
            fill: false
          },
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.containersShippedTemporaryValuesDeposit),
            label: 'Despachado',
            borderColor: constants.colorPalette.TemporaryDepositShipped,
            fill: false
          }
        ]
      }
    },
    showDetail () {
      this.$parent.showDetail('temporaryDesposit')
    }
  },
  components: {
    'chart-line': LineChart
  }
}
</script>




// WEBPACK FOOTER //
// TemporaryDepositSummary.vue?95bc5de4